import React from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router-dom';
import { Theme } from '../../config/theme';

import ContentContainer from '../ContentContainer';

let styles;

const BRAND1 = require('./brands/1.jpg');
const BRAND2 = require('./brands/2.jpg');
const BRAND3 = require('./brands/3.jpg');
const BRAND4 = require('./brands/4.jpg');
const BRAND6 = require('./brands/6.jpg');
const BRAND7 = require('./brands/7.jpg');
const BRAND8 = require('./brands/8.jpg');
const BRAND9 = require('./brands/9.jpg');
const BRAND10 = require('./brands/10.jpg');
const BRAND11 = require('./brands/11.jpg');
const BRAND12 = require('./brands/12.jpg');
const BRAND13 = require('./brands/13.jpeg');
const BRAND14 = require('./brands/14.jpg');
const BRAND15 = require('./brands/15.jpg');
const BRAND16 = require('./brands/16.jpeg');
const BRAND17 = require('./brands/17.jpg');

const BRAND18 = require('./brands/18.jpg');
const BRAND19 = require('./brands/19.jpg');
const BRAND20 = require('./brands/20.jpg');
const BRAND21 = require('./brands/21.jpg');
const BRAND22 = require('./brands/22.jpeg');
const BRAND23 = require('./brands/23.png');

const DONATION_PRICE = 1.00;

export default () => (
  <div className={css(styles.container)}>
    <ContentContainer>
      <h2 className={css(styles.heading)}>We support local charities</h2>
      <p className={css(styles.paragraph)}>
        ${DONATION_PRICE.toFixed(2)} of your membership fee goes towards a dog
        charity of your choosing
      </p>
      <div className={css(styles.logos)}>
        <div className={css(styles.charity)}>
          <img src={BRAND1} alt="The Underdogs Foundation" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND2} alt="Hurrah" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND3} alt="SPCA" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND4} alt="SAFE" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND6} alt="Auckland Puppy Rescue" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND7} alt="Assistance Dogs New Zealand Trust" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND8} alt="Ruakaka Dog Rescue" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND9} alt="Mobility Dogs" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND10} alt="HUHA" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img
            src={BRAND11}
            alt="Chained Dog Rehabilitation and Rehoming NZ"
            className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND12} alt="Rottweiler Rescue & Rehoming" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND13} alt="Aspiring Avalanche Dogs" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND14} alt="Blind Foundation Guide Dogs" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND15} alt="NZ Chihuahua Rescue" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND16} alt="Dog Rescue Dunedin" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND17} alt="Nightrave Greyhounds" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND18} alt="Christchurch Bull Breed Rescue" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND19} alt="Dogwatch Sanctuary Trust" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND20} alt="Hearing Dogs" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND21} alt="New Lives Animal Rescue" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND22} alt="Saving Hope" className={css(styles.logo)} />
        </div>
        <div className={css(styles.charity)}>
          <img src={BRAND23} alt="We Love Dogs" className={css(styles.logo)} />
        </div>
      </div>
      <Link to="/story" className={css(styles.btn)}>Find out more</Link>
    </ContentContainer>
  </div>
);

styles = StyleSheet.create({
  container: {
    padding: '108px 0',
    textAlign: 'center',
    backgroundColor: '#fff',

    [Theme.mobile_query]: {
      height: 'auto',
      padding: '40px 0 50px',
    },
  },
  heading: {
    marginBottom: 15,
    fontFamily: Theme.font_family_heading,
    fontSize: 30,
    fontWeight: Theme.font_weight_heading,
    lineHeight: 1.17,
    color: '#262626',
  },
  paragraph: {
    marginBottom: 45,
    fontFamily: Theme.font_family_primary,
    fontSize: 20,
    fontWeight: 500,
    color: '#000e1f',
  },
  logos: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: 920,
    margin: '0 auto 46px',

    [Theme.mobile_query]: {
      width: 'auto',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginBottom: 20,
    },
  },
  charity: {
    width: '20%',
    marginBottom: 15,
    [Theme.mobile_query]: {
      padding: 15,
      width: '50%',
    },
  },
  btn: {
    display: 'block',
    height: 50,
    width: 229,
    margin: '0 auto',
    padding: '0 40px',
    textTransform: 'uppercase',
    fontSize: 15,
    fontWeight: 900,
    fontFamily: Theme.font_family_secondary,
    lineHeight: '50px',
    letterSpacing: 2,
    textAlign: 'center',
    color: Theme.white,
    borderRadius: 5,
    border: 0,
    backgroundColor: '#000e1f',
    cursor: 'pointer',
    outline: 'none',
    transition: 'background-color 300ms',

    ':hover': {
      backgroundColor: '#333e4c',
    },
  },
  logo: {
    maxWidth: 115,
    maxHeight: 102,
  },
});



// WEBPACK FOOTER //
// ./src/components/Charities/index.js